import { request } from '@tencent/ppd-base-libs';

const inListStatus = {
  // 不在名單中
  notIn: 0,
  // 在名單中
  in: 1,
};

/**
 * 查询黑白名单
 * @param actListId:用户包actListId, qryType: 1为白名单，0为黑名单
 * @returns
 */
//  https://apps.wechatpay.com.hk/cgi-bin/refill/prom_check_act_blacklist.fcgi
//  qry_type=1&act_listid=20220303965986201
export async function getBlackList({ actListId, qryType }: { actListId: string; qryType: string }) {
  const t = new Date().getTime();
  const result = await request.get('/cgi-bin/refill/prom_check_act_blacklist.fcgi', {
    params: {
      act_listid: actListId,
      qry_type: qryType,
      t, // 加上时间戳，避免奇怪的问题
    },
  });
  // 需要判断is_expired：1-活动未开始或已结束，0-未过期
  if (+result.is_expired === 1) {
    return false;
  }
  if (+qryType === 1) {
    // 查白名单，且用户在白名单中
    return +result.is_white === inListStatus.in;
  }
  // 查黑名单，且用户不在黑名单中
  return +result.is_black === inListStatus.notIn;
}